module.exports = __webpack_public_path__ + "img/ctrl-v-stub-up-0.453ea201.svg";